var React = require('react');

function PlayBig (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M38 76C58.9868 76 76 58.9868 76 38C76 17.0132 58.9868 0 38 0C17.0132 0 0 17.0132 0 38C0 58.9868 17.0132 76 38 76ZM32 30.7232V47.2768C32 48.0446 32.8295 48.526 33.4961 48.1451L47.9806 39.8682C48.6524 39.4843 48.6524 38.5157 47.9806 38.1318L33.4961 29.8549C32.8295 29.474 32 29.9554 32 30.7232Z","fill":"white"}));
}

PlayBig.defaultProps = {"width":"76","height":"76","viewBox":"0 0 76 76","fill":"none"};

module.exports = PlayBig;

PlayBig.default = PlayBig;
